import React, {Dispatch, lazy, SetStateAction, Suspense} from 'react';
import {useSelector} from 'react-redux';
import {CircularProgress} from '@material-ui/core';
import {TableVariants} from '@pluto/table';
import {isEmptyArr} from '@pluto/utils';
import SearchNoResult from './SearchNoResults';
import searchTableColumns from './SearchColumns';
import {selectSearchResults, selectStatusesObject} from './Redux/SearchSelectors';
import {ContentItemSearchPayload, Statuses} from './SearchTypes';

const MAX_ITEMS_RESULT = 10000;
const Table = lazy(() => import('@pluto/table'));

interface Props {
    searchQuery: string;
    page: number;
    setPage: Dispatch<SetStateAction<number>>;
    rowsPerPage: number;
    setRowsPerPage: Dispatch<SetStateAction<number>>;
    onPaging: () => void;
}

function SearchTable({
    searchQuery,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    onPaging,
}: Props) {
    const {rows = [], total, isLoading} = useSelector(
        selectSearchResults
    ) as ContentItemSearchPayload;

    const statuses = useSelector(selectStatusesObject) as Statuses;

    return (
        <div className="search-table">
            {isEmptyArr(rows) ? (
                <SearchNoResult isLoading={isLoading} />
            ) : (
                <>
                    <div className="search-table-title">
                        <span>{`Showing ${total}${
                            total >= MAX_ITEMS_RESULT ? '+' : ''
                        } results ${searchQuery ? `for "${searchQuery}"` : ''}`}</span>
                    </div>
                    <Suspense fallback={<CircularProgress />}>
                        <Table
                            data={rows}
                            columns={searchTableColumns(searchQuery, statuses)}
                            onChangePageHandler={onPaging}
                            page={page}
                            setPage={setPage}
                            rowsPerPage={rowsPerPage}
                            setRowsPerPage={setRowsPerPage}
                            isLoading={isLoading}
                            total={total}
                            variant={TableVariants.dark}
                        />
                    </Suspense>
                </>
            )}
        </div>
    );
}

export default React.memo(SearchTable);
